import { createAction, createSlice } from "@reduxjs/toolkit";

const getInstructorProfileSlice = createSlice({
  name: "getInstructorProfile",
  initialState: { data: {}, processing: false },
  reducers: {
    pending(state) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.data = action.payload.data;
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
    reset(state) {
      state.data = {};
    },
  },
});

const { name, actions, reducer } = getInstructorProfileSlice;
const getInstructorProfileAction = createAction(name);

export {
  getInstructorProfileAction,
  actions as getInstructorProfileActions,
  reducer as getInstructorProfileReducer,
};
